import { useCurrency } from '../context/CurrencyContext';
import { CURRENCY_OPTIONS } from '../utils/currency';
import { useTranslation } from 'react-i18next';
import { X } from '@phosphor-icons/react';
import { Button } from './ui/button';

export const CurrencySuggestion = () => {
  const { suggestion, acceptSuggestion, dismissSuggestion } = useCurrency();
  const { t } = useTranslation();

  if (!suggestion) return null;

  const opt = CURRENCY_OPTIONS[suggestion.currency];

  return (
    <div className="fixed bottom-24 md:bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4 fade-in duration-300" data-testid="currency-suggestion">
      <div className="bg-white border border-border rounded-2xl shadow-lg px-5 py-4 flex items-center gap-4 max-w-sm">
        <p className="text-sm text-text_main flex-1">
          {t('currency.suggestion', { symbol: opt.symbol })}
        </p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            onClick={acceptSuggestion}
            variant="primary"
            size="sm"
            data-testid="currency-accept-btn"
          >
            {t('common.yes')}
          </Button>
          <button
            onClick={dismissSuggestion}
            className="p-1.5 text-text_muted hover:text-text_main hover:bg-surface rounded-full transition-colors"
            data-testid="currency-dismiss-btn"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};
